// 获取URL传入的对象属性
export function getUrlDataString(source, path, defaultValue = undefined) {
  try {
    const paths = path.replace(/\[(\d+)\]/g, '.$1').split('.')
    let result = source
    for (const p of paths) {
      result = Object(result)[p]
      if (result === undefined) {
        return defaultValue
      }
    }
    if (Object.prototype.toString.call(result) == '[object Array]') {
      return result[0]
    }
    return result
  } catch (err) {
    console.error(err)
    return defaultValue
  }
}

export function getUrlSameParams(url) {
  const len = url.indexOf('?')
  const str = url.slice(len + 1)
  const arr = str.split('&')
  let obj = {}
  // 这里创建一个数组用来存放同参数的属性值
  let arrList = []
  // 这里需要判断一下arr中是否有重复的参数，如果有，提取出参数的名称
  // 创建用于存放重复的字符串，这里只考虑只有一个重复的参数
  let repeatName = ''
  // 判断重复，并且提取出重复的值
  function repeat(arr) {
    let repeat_arr = []
    for (let key in arr) {
      const repeat_l = arr[key].indexOf('=')
      const repeat_k = arr[key].slice(0, repeat_l)
      if (repeat_arr.includes(repeat_k)) {
        // console.log('有重复', repeat_k);
        repeatName = repeat_k
      } else {
        repeat_arr.push(repeat_k)
      }
    }
    // console.log(repeat_arr);
  }
  repeat(arr)
  // 这里循环处理对象中的属性
  for (let key in arr) {
    // console.log(arr[key])
    const l = arr[key].indexOf('=')
    const k = arr[key].slice(0, l)
    const v = arr[key].slice(l + 1)
    if (k === repeatName) {
      // 这里进行判断，当k等于重复的那个参数时，向数组内添加该参数的属性值
      arrList.push(v)
      obj[k] = arrList
      // 将对象的value设置为空数组
    } else {
      // 当k不是重复参数时，正常向对象中添加属性值
      obj[k] = v
    }
  }
  return obj
}

// 取倒计时(天时分秒)
export function getTimeLeft(mss) {
  // 将时间差(毫秒)格式为：天时分秒
  let days = parseInt(mss / (60 * 60 * 24))
  let hours = parseInt((mss % (60 * 60 * 24)) / (60 * 60))
  let minutes = parseInt((mss % (60 * 60)) / 60)
  if (minutes < 10) {
    minutes = '0' + minutes
  }
  let seconds = parseInt((mss % 60))
  if (seconds < 10) {
    seconds = '0' + seconds
  }
  let obj = {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  }
  return obj
  // if (days >= 1) {
  //   return days + '天' + hours + '时' + minutes + '分' + seconds + '秒'
  // } else if (hours >= 1) {
  //   return hours + '时' + minutes + '分' + seconds + '秒'
  // } else if (minutes >= 1) {
  //   return minutes + '分' + seconds + '秒'
  // } else {
  //   return seconds + '秒'
  // }
}

// 获取对象属性值
export function get(source, path, defaultValue = undefined) {
  try {
    const paths = path.replace(/\[(\d+)\]/g, '.$1').split('.')
    let result = source
    for (const p of paths) {
      result = Object(result)[p]
      if (result === undefined) {
        return defaultValue
      }
    }
    return result
  } catch (err) {
    console.error(err)
    return defaultValue
  }
}
/**
 * 表格时间格式化
 */
export function formatDateDay(cellValue, isNotTime, isNotTimeCN) {
  if (cellValue == null || cellValue == '') return ''
  var date = new Date(cellValue)
  var year = date.getFullYear()
  var month = date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  var day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  var hours = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  var minutes = date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  var seconds = date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let returnData = ''
  if (isNotTime) {
    if (isNotTimeCN) {
      returnData = year + '年' + month + '月' + day + '日'
    } else {
      returnData = year + '-' + month + '-' + day
    }
  } else {
    returnData = year + '-' + month + '-' + day + ' ' + hours + ':' + minutes + ':' + seconds
  }
  return returnData
}

/**
 * 分转元（保留两位小数）
 */
export function regFenToYuan(fen, defaultNum = 0) {
  let num = fen
  try {
    if (num) {
      num = (fen / 100).toFixed(2)
      return Number(num)
    } else {
      return defaultNum
    }
  } catch (e) {
    console.log('----------------转化金额出错', e)
    return defaultNum
  }
}

// 对象转query字符串的方法
export function query(obj) {
  // 首先判断obj是否为真，为真则进行处理，不然直接return
  if (obj) {
    // 定义变量接收query字符串
    let query = ''
    // 循环遍历对象
    for (let i in obj) {
      // 定义变量接收对象的value值
      let value = obj[i]
      // 若对象的value值为数组，则进行join打断
      if (Array.isArray(value)) {
        value = value.join(',')
      }
      // 进行字符串拼接
      query += `&${i}=${value}`
    }
    // replace返回一个新的字符串，要用query重新接受一下，并把第一个&替换为?
    query = query.replace('&', '?')
    // 返回生成的query字符串
    return query
  }
  return ''
}

// 处理 utm 特殊字段
export function getUtmRightValue(source, path, defaultValue = undefined) {
  try {
    const paths = path.replace(/\[(\d+)\]/g, '.$1').split('.')
    let result = source
    if(!result) return defaultValue
    for (const p of paths) {
      result = Object(result)[p]
      if (result === undefined) {
        return defaultValue
      }
    }
    if (Object.prototype.toString.call(result) == '[object Array]') {
      return result[0].length > 100 ? result[0].substr(0, 100) + '' : result[0] + ''
    } else if (result.includes('[')) {
      let resultVal = result.split(',')[0]
      resultVal = resultVal.replace('[', '')
      resultVal = resultVal.includes('?') ? resultVal.split('?')[0] : resultVal
      return resultVal.length > 100 ? resultVal.substr(0, 100) + '' : resultVal + ''
    } else if (result.includes('?')) {
      let resultVal = result.split('?')[0]
      return resultVal.length > 100 ? resultVal.substr(0, 100) + '' : resultVal + ''
    } else {
      return result.length > 100 ? result.substr(0, 100) + '' : result + ''
    }
  } catch (err) {
    console.error(err)
    return defaultValue
  }
}
